import React, { useState, useRef } from 'react';

import * as turf from '@turf/turf';

import {
    Alert,
    Card,
    Input,
    Checkbox,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
    Button,
    Typography,
    IconButton,
    Radio,
    Tab,
    Tabs,
    TabsBody,
    TabsHeader,
    TabPanel,
    Tooltip,
    Select,
    Option,
    Textarea,

} from "@material-tailwind/react";
//import Select from 'react-select';

import {
    TruckIcon,
    TrashIcon,
    BeakerIcon,
    ChatBubbleLeftIcon,
    EnvelopeIcon,
    FingerPrintIcon,
    ChevronDoubleUpIcon,
    ChevronDoubleDownIcon,
    XMarkIcon

} from "@heroicons/react/24/outline";


import Datepicker from "react-tailwindcss-datepicker";
import { getFields } from './AdminTools.jsx';
import { showAlert } from './Alert.jsx';

import { PdfPreview } from "./LabForm";

import SmsCard from './SmsCard.jsx';
import EmailCard from './EmailCard.jsx';
import FieldsCheckList from './FieldsCheckList;.jsx';
import OrderHistoryList from './OrderHistoryCard.jsx';
import { filter } from 'jszip';
import { filterProperties } from '@turf/turf';

export default function OrderAdminCard(props) {

    const [fields, setFields] = useState(JSON.parse(localStorage.getItem("fields")) || []);
    const [offers, setOffers] = useState(JSON.parse(localStorage.getItem("offers")) || []);
    //const [orders, setOrders] = useState(JSON.parse(localStorage.getItem("orders")) || []);
    const [orders, setOrders] = useState(props.orders || []);
    const [orderId,setOrderId ] = useState(props.id || 0);
    const [clients, setClients] = useState(JSON.parse(localStorage.getItem("clients")) || []);
    const [crew, setCrew] = useState(JSON.parse(localStorage.getItem("crew")) || []);

    const [vehicles, setVehicles] = useState(JSON.parse(localStorage.getItem("vehicles")) || []);
    const [selectedVehicle, setSelectedVehicle ] = useState("");
    
    const [techs, setTechs ] = useState([]);
    const [selectedTech, setSelectedTech ] = useState("");
    const [techName, setTechName ] = useState();

    const [rank] = useState(localStorage.getItem("rank") || 0);
    const [userid] = useState(localStorage.getItem("userid") || 0);
    const [username] = useState(localStorage.getItem("username"));


    const [clientFields, setClientFields] = useState();
    const [selectedFields, setSelectedFields] = useState([]);
    const [fieldsToProbe, setFieldsToProbe] = useState([]);
    const [completionList, setCompletionList] = useState([]);

    const [action, setAction] = useState('create');

    const [field, setField] = useState();
    const [offer, setOffer] = useState();
    const [order, setOrder] = useState();
    const [client, setClient] = useState();

    const [minDate, setMinDate] = useState();
    const [maxDate, setMaxDate] = useState();

    const [area, setArea] = useState();

    const [estimatedValue, setEstimatedValue] = useState();

    const [description, setDescription] = useState('');
    const [name, setName] = useState('');
    const [proposaldate, setProposalDate] = useState({ startDate: null, endDate: null });
    const [finalDate, setFinalDate] = useState({ startDate: null, endDate: null });
    



    const [progress, setProgress] = useState(1);
    const [status, setStatus] = useState('Zlecenie zgłoszone do realizacji');
    const [message, setMessage] = useState('Twoje zlecenie w portalu Agro-Online zmieniło status');
    const [subject, setSubject] = useState('Twoje zlecenie zmieniło status');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [clientName, setClientName] = useState('');

    const [showHistoryCard, setShowHistoryCard] = useState(false);
    const [showSmsCard, setShowSmsCard] = useState(false);
    const [showEmailCard, setShowEmailCard] = useState(false);
    const [showPDF, setShowPDF] = useState(false);
    const [showFieldList,setShowFieldList] = useState(true);

    const [authenticated, setAuthenticated] = useState(localStorage.getItem("authenticated") || false);
    const [session, setSession] = useState(localStorage.getItem("session") || null);


    const [confirm, setConfirm] = useState(false);
    const [refreshAfterExit, setRefreshAfterExit] = useState(false);
    const [closeOnSend, setCloseOnSend] = useState(false);


    const [offerPrice, setOfferPrice] = useState();
    //const [finalValue, setFinalValue] = useState();
    //const [jobNumber, setJobNumber] = useState("");
    //const [fieldMark, setFieldMark] = useState("");
    //const [probesCount, setProbesCount] = useState(0);
    const [labData, setLabData] = useState({});


    const [parameters, setParameters] = useState({
        finalValue: 0,
        jobNumber:"",
        fieldMark:"",
        probesCount:0
    });


    const PROGRESS = [
        { id: 1, status: "Zlecenie otwarte do wyboru pól" },
        { id: 2, status: "Zlecenie zgłoszone do realizacji", isdisabled: true },
        { id: 3, status: "Zlecenie przyjęte do wyceny" },
        { id: 5, status: "Zlecenie gotowe do akceptacji" },
        { id: 10, status: "Zlecenie zaakceptowane" },
        { id: 25, status: "Technik w drodze na wyznaczone pola" },
        { id: 30, status: "Pobieranie próbek z pola" },
        { id: 35, status: "Pobrano część próbek" },
        { id: 40, status: "Zakończono pobieranie próbek" },
        { id: 45, status: "Przygotowywanie próbek do wysyłki" },
        { id: 50, status: "Próbki zostały wysłane do laboratorium" },
        { id: 60, status: "Oczekianie na dane z laboratorium" },
        { id: 80, status: "Opracowywanie danych z laboratorium" },
        { id: 100, status: "Zlecenie zakończone - dane dostępne" },
    ]




    React.useEffect(() => {
        
        if (crew.length>0)
        {
            let technicy = crew.filter(c => c.rank == 5);
            setTechs(technicy);
        }
        
            else 
                {
                    getCrew();
                }
        

        let order = {};
        if (orders.length > 0) {
            let ordersarray = orders.filter(o => o.id == props.id);
            if (ordersarray.length == 1) {
                order = ordersarray[0];
                setOrder(order);
                setOrderId(props.id);
                setEstimatedValue(order.estimatedvalue);
                setDescription(order.description);
                setProgress(order.progress);
                
                if (order.techid) setSelectedTech(order.techid.toString());
                if (order.vehicle) setSelectedVehicle(order.vehicle.toString());
        
                var selected=JSON.parse(order.fieldlist);
                setSelectedFields(selected);
                

                if (order.properties) {
                    let properties = JSON.parse(order.properties)
                    parameters.jobNumber=properties.jobnumber;
                    parameters.probesCount=properties.probes;
                    parameters.fieldMark=properties.fieldmark;
                    if (properties.completion) { setCompletionList(properties.completion); }
                }

                if (order.finalvalue) 
                    {
                        parameters.finalValue=Number(order.finalvalue);
                    }
            }
        }

        if (props.id > 0) {
            
            setAction('update');
            setOrderId(props.id);
            if (order.finaldate)
                setFinalDate(JSON.parse(order.finaldate));
            
            if (order.techid) setSelectedTech(order.techid.toString());
            if (order.vehicle) setSelectedVehicle(order.vehicle.toString());
            
            if (order.proposaldate) {
                let propdate = JSON.parse(order.proposaldate);
                setProposalDate(propdate);
                try {
                    setMinDate(propdate.startDate);
                    setMaxDate(propdate.endDate);
                } catch { console.log('error setting min max date') };
            }

            let offerarray = offers.filter(o => o.id == order.offerid);
            if (offerarray.length == 1) {
                let offer = offerarray[0];
                setOffer(offer);
            }
            else
            {
                setOffer(offers[0]);
            }

            let fieldarray = fields.filter(f => f.owner == order.ownerid);
            console.log("fields");
            console.log(fields);

            console.log("field array");
            console.log(fieldarray);
            if (order.ownerid) {
                let clientarray = clients.filter(c => c.id == order.ownerid);
                if (clientarray.length == 1) {
                    let client = clientarray[0];
                    setClient(client);
                }
            }


            if (fieldarray.length > 0) {
                let field = fieldarray[0];
                if (field) setField(field);
                

                let clientarray = clients.filter(c => c.id == order.ownerid);
                console.log("client array");
                console.log(clientarray);
                if (clientarray.length == 1) {
                    let client = clientarray[0];
                    setClient(client);
                    setEmail(client.email);
                    setPhone(client.phone);
                    setClientName(client.name);
                    setField(field);
                    getFields(session,setClientFields,client.id);
                    //setFieldId(field.id);
                }
            }
        }
        else {
            if (offers.length > 0) {
                setOffer(offers[0]);
            }

        }

    }, []);


    React.useEffect(() => {
        console.log("effect clientFields");
        console.log(clientFields);
        if (!clientFields) return;
        

        let area_sum=0;
        clientFields.forEach(field => {
            if (selectedFields.includes(field.id)) { field.selected=true; area_sum+=Number(field.area); }
            else  { field.selected=false; }
        });
        setArea(area_sum);
        selectFieldsToProbe();

    }, [clientFields]);




    React.useEffect(() => {
        if (crew.length>0)
        {
            let technicy = crew.filter(c => c.rank == 5);
            setTechs(technicy);
        }
    }, [crew]);

/*
    React.useEffect(() => {
        console.log('SELECTED TECH CHANGED ' + selectedTech);    
        if (selectedTech>0)
            {
                let onetech=crew.filter(c=> c.id==selectedTech)
                if (onetech.length==1)
                {
                    console.log('onetech ');
                    console.log(onetech);
                    setTechName(onetech[0].firstname + " " + onetech[0].lastname);
                    console.log(onetech[0].firstname + " " + onetech[0].lastname);
                }
            }
    }, [selectedTech]);

*/

    function selectFieldsToProbe() //and show on map
    {
        var _fieldsToProbe;
        _fieldsToProbe = clientFields.filter(cf=>cf.selected==true);
        
        setFieldsToProbe(_fieldsToProbe); //może byc niepotrzebne
        buildFeatureCollection(_fieldsToProbe);

    }



    function getCrew() {
        //console.log('crewlist');
        var bodydata = JSON.stringify({ action: 'crewlist', session: session });
        //console.log(bodydata);
        fetch('https://online.mysoil.pl/cgi-bin/user.py', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: bodydata,
            mode: 'cors'

        })
            .then(res => res.json())
            .then(data => { console.log(data); setCrew(data.crew); localStorage.setItem("crew", JSON.stringify(data.crew)); })

    }


    function handleParamChange(e) {
        const { name, value } = e.target;
        setParameters(prev => ({ ...prev, [name]: value }));
        
    }





    function getFieldArea(fid) {
        let field = fields.filter(f => f.id == fid)[0];
        if (field) { return field.area; }
        else { return 0; }
    }


    function cancelClose() {
        props.Close(refreshAfterExit);
    }


    function handleDataResponse(data) {

        //console.log(data)
        //setUploaded(true);
        if (data.status === "ok") {
            showAlert("green", data.message, 4000);
            setRefreshAfterExit(true);
            
            if (closeOnSend) { props.Close(refreshAfterExit); }
        }
        if (data.status !== "ok") {
            showAlert("red", data.message, 4000);
        }
    }


    function handleQuietResponse(data) {
        //setUploaded(true);
        if (data.status === "ok") {
            console.log(data)
        }
        if (data.status !== "ok") {
            showAlert("red", data.message, 4000);
        }
    }




    function deleteOrder() {

        let _orderid = 0;
        if (order) {
            _orderid = order.id;
        }
        let _fieldid = 0;
        if (field) {
            _fieldid = field.id;
        }

        let bodydata = JSON.stringify({ action: 'remove', session: session, id: _orderid, fieldid: _fieldid });
        //console.log(bodydata);

        setConfirm(false);
        setCloseOnSend(true);

        fetch('https://online.mysoil.pl/cgi-bin/orders.py', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: bodydata,
            mode: 'cors'
        })
            .then(res => res.json())
            .then(data => handleDataResponse(data))
    }


    function getSelectedFieldsIds() {
        var selectedarray = [];
        var selected=clientFields.filter((field) => field.selected===true);
        
        selected.forEach(element => {
            selectedarray.push(Number(element.id));
        });
        
        
        return selectedarray;
    }


    function getSelectedFieldsName(selected) {
        var name="";
        var select=fields.filter((field) => selected.includes(field.id));

        if (select.length==1) name=select[0].name;
        if (select.length>1) name="Wiele pól (" + select.length +")";

        return name;
    }


    function wasChanged(nowy,stary,opis)
    {
        
        var result=null;
        if ((!nowy) && (!stary)) return result;
        /*
        console.log("nowy");
        console.log(nowy);
        console.log("stary");
        console.log(stary);
        */
        if (nowy!=stary)
        {
            result=opis + " (";
            if (stary) result+=stary.toString();
            else result+="undef";
            result+="->";
            if (nowy) result+=nowy.toString();
            else result+="undef";
            result+=")";
        }
        return result;
    }

    function wasChangedFields(nowy,stary,opis)
    {
        var result=null;
        if ((!nowy) && (!stary)) return result;

        
        if ((nowy.length === stary.length) && (nowy.slice().sort().every(function(value, index) { return value === stary[index];  })))    
        { }
        else
        {
            result=opis + " (";
            if (stary) result+=stary.toString();
            else result+="undef";
            result+="->";
            if (nowy) result+=nowy.toString();
            else result+="undef";
            result+=")";
        }
        return result;
    }








  function buildFeatureCollection(fields) {
    let newfc = {
      type: "FeatureCollection",
      features: []
    }


    fields.forEach(field => {
      let fieldshape = JSON.parse(field.shape);
      if (field.selected == true) {
        var comp=completionList.filter(c=>c.id==field.id)[0];
        var value=5;
        if (comp && (comp.completion==1)) value=4; 
        if (comp && (comp.completion==2)) value=1; 
        fieldshape.features.forEach(feature => {
          //feature.properties.value=1;  
          
          feature.properties.fieldid = field.id;
          feature.properties.value = value;
          //feature.properties.value = getExamValue(feature.examtime); //feature.examined
          feature.properties.polygonName=field.name; //feature.examined
          newfc.features.push(feature);
        });
      }
    });
    //console.log("newfc");
    //console.log(newfc);
    
    if (newfc.features.length>0) showGeoJson(newfc, false);
  }


function showGeoJson(features, refresh) {
    if (!features) return;
    

    let bounds = turf.bbox(features);
    let resizedbounds = resizeBoundingBox(bounds);

    applyFeatureCollection(features);
    applyBoundingBox(resizedbounds);
  }


  function resizeBoundingBox(bounds) {
    var point1 = turf.point([bounds[0], bounds[1]]);
    var point2 = turf.point([bounds[2], bounds[3]]);
    var bearing = turf.bearing(point1, point2);
    var distance = turf.distance(point1, point2);
    var p1 = turf.destination(point1, -0.2 * distance, bearing);
    var p2 = turf.destination(point2, 0.2 * distance, bearing);
    var box = [p1.geometry.coordinates[0], p1.geometry.coordinates[1], p2.geometry.coordinates[0], p2.geometry.coordinates[1]];
    return box;
  }


  function applyFeatureCollection(collection) {
    localStorage.setItem('featureCollection', JSON.stringify(collection));
    dispatchEvent(new Event("featureCollectionChanged"));
  }


  function applyBoundingBox(bounds) {
    localStorage.setItem('boundingBox', JSON.stringify(bounds));
    dispatchEvent(new CustomEvent('boundingBoxChanged', { detail: bounds })); 
  }


  function startTrackingOrder()
  {
    console.log("will track order");
    console.log(order);
    var props;
    try
    {
    props=JSON.parse(order.properties);
    }
    catch { props={} }
    
    
    props.completion=completionList;
    order.properties=JSON.stringify(props);
    dispatchEvent(new CustomEvent('trackOrder', { detail: { order: order } })); 
  }





    function buildHistoryEntry(selected)
    {
        var changes=[];
        var nowy,stary;
        var change=null;
        var properties;
        try
        {
        properties=JSON.parse(order.properties);
        changes.push("(Utworzono nowe zlecelnie)");
        }
        catch { properties={} }
        
        if (order)
        {
        nowy=selected; stary=JSON.parse(order.fieldlist);
        
        change=wasChangedFields(nowy,stary,"Zmiana listy pól ");
        if (change!=null) changes.push(change);



        //////////////////////////////////////
        nowy=client.id; stary=order.ownerid;

        var klient=clients.filter(c=> c.id==nowy);
        if (klient.length>0) nowy=klient[0].name;
        klient=clients.filter(c=> c.id==stary);
        if (klient.length>0) stary=klient[0].name;

        change=wasChanged(nowy,stary,"Zmiana klienta ");
        if (change!=null) changes.push(change);

        /////////////////////////////////
        nowy=offer.id; stary=order.offerid;
        
        var oferta=offers.filter(o=> o.id==nowy);
        if (oferta.length>0) nowy=oferta[0].name;
        oferta=offers.filter(o=> o.id==stary);
        if (oferta.length>0) stary=oferta[0].name;

        change=wasChanged(nowy,stary,"Zmiana oferty");
        if (change!=null) changes.push(change);
        /////////////////////////////////

        nowy=progress; stary=order.progress;
        change=wasChanged(nowy,stary,"Zmiana postępu prac");
        if (change!=null) changes.push(change);

        nowy=parameters.probesCount; stary=properties.probes;
        change=wasChanged(nowy,stary,"Zmiana ilości próbek");
        if (change!=null) changes.push(change);

        nowy=parameters.jobNumber; stary=properties.jobnumber;
        change=wasChanged(nowy,stary,"Zmiana numeru zlecenia ");
        if (change!=null) changes.push(change);

        nowy=parameters.fieldMark; stary=properties.filedmark;
        change=wasChanged(nowy,stary,"Zmiana oznaczenia pola ");
        if (change!=null) changes.push(change);

        try
        {
        nowy=finalDate.startDate; stary=JSON.parse(order.finaldate).startDate;
        change=wasChanged(nowy,stary,"Zmiana daty zlecenia ");
        if (change!=null) changes.push(change);
        }
        catch { console.log("nowy"); console.log(nowy); console.log("stary"); console.log(stary);  console.log("order"); console.log(order); }

        nowy=parameters.finalValue; stary=order.finalvalue;
        change=wasChanged(nowy,stary,"Zmiana kwoty zlecenia ");
        if (change!=null) changes.push(change);
        
        //wybieramy nazwę pojazdu
        nowy=Number(selectedVehicle); stary=order.vehicle;
        var pojazdy=vehicles.filter(f => f.esn==nowy);
        if (pojazdy.length==1) nowy=pojazdy[0].name;
        pojazdy=vehicles.filter(f => f.esn==stary);
        if (pojazdy.length==1) stary=pojazdy[0].name;
        change=wasChanged(nowy,stary,"Zmiana pojazdu ");
        if (change!=null) changes.push(change);
            
        
        nowy=techName; stary=properties.techname;
        change=wasChanged(nowy,stary,"Zmiana technika ");
        if (change!=null) changes.push(change);

        };

        var date = new Date();
        const options = { year: "numeric", month: "long", day: "numeric",};

        var datestr = date.toLocaleDateString("pl-PL",options) + " " + date.toLocaleTimeString();
        var entry = { user : username, date: datestr, changes:changes };
        
        console.log("---- entry-----");
        console.log(entry);
        return entry;
    }



    function buildHistory(localprops, selected)
    {
        var properties;
        try
        {
        properties=JSON.parse(order.properties);
        
        }
        catch { properties={} }

        
        if (!(typeof properties === 'object') && (properties !== null)) properties={}; //initialize properties as object

        if (!properties.history) { properties.history=[]; }
        var entry = buildHistoryEntry(selected);    
        
        if (entry.changes.length>0) properties.history.push(entry);
        localprops.history=properties.history;
    }



    function handleSubmit(e) {
        e.preventDefault();


        let _orderid = 0;
        if (order) {
            _orderid = order.id;
        }

        let properties = {
            probes: parameters.probesCount,
            jobnumber: parameters.jobNumber,
            fieldmark: parameters.fieldMark,
            techname: techName,
            completion: completionList
        }
        
        setRefreshAfterExit(true);

        var selected=getSelectedFieldsIds();
        var name=getSelectedFieldsName(selected);
        
        setSelectedFields(selected);
        let _fieldid = 0;
        if (field) {
            _fieldid = field.id;
        }
        if ((_fieldid==0) && (selected.length>0))
        {
            _fieldid=selected[0];
        }


        
        buildHistory(properties,selected);

        let bodydata = JSON.stringify({
            action: action, session: session, id: _orderid, name: name, description: description, proposaldate: JSON.stringify(proposaldate), finaldate: JSON.stringify(finalDate), area:area,
            fieldid: _fieldid, ownerid: client.id , offerid: offer.id, techid: Number(selectedTech), vehicle: Number(selectedVehicle),properties: JSON.stringify(properties), offerprice: offerPrice, finalvalue: parameters.finalValue, progress: progress, fieldlist: JSON.stringify(selected), status: status
        });
        setCloseOnSend(false);
        
        //console.log(bodydata);


        selectFieldsToProbe();    
        if ((rank==5) && (progress >= 20) && (progress <= 40)) { startTrackingOrder(); }    
        
        
        fetch('https://online.mysoil.pl/cgi-bin/orders.py', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: bodydata,
            mode: 'cors'
        })
            .then(res => res.json())
            .then(data => handleDataResponse(data))

        

        // mark field as probed or not  
        /*
        let probing="stop"
        if ((progress >= 30) && (progress < 40)) { probing="start"; }    
        
        if ((progress >= 30) && (progress <= 80)) {
        bodydata = JSON.stringify({ action: probing, session: session, id: client.id, vehicle: Number(selectedVehicle) });
            console.log(bodydata);
            fetch('https://online.mysoil.pl/cgi-bin/fields.py', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: bodydata,
                mode: 'cors'
            })
                .then(res => res.json())
                .then(data => handleQuietResponse(data))
        }
        */
    }



    function onSelectClientChange(e) {
        //setClientFields(fields.filter(f => f.owner == e))
        console.log('select client change e');
        console.log(e);
        setClient(clients.filter(c => c.id == e)[0]);
        //getFields(session, setFields, e);
        setSelectedFields([]);
        getFields(session, setClientFields, e);
    }


    function onSelectFieldChange(e) {
        console.log("field changed  " + e);
        setField(fields.filter(f => f.id == e)[0])
    }


    function onChangeCompletion(fieldid,completion)
        {
            if (completionList)
            {
                var compList=completionList.filter(c=>c.id!==fieldid);
                compList.push({id:fieldid, completion: completion});
                setCompletionList(compList);
            }
            else
            {
                setCompletionList([{id:fieldid, completion: completion}]); //first entry
            }
            selectFieldsToProbe();
        }



    function generateLabForm() {
        let today = new Date().toLocaleDateString();
        let data = {
            client: client,
            field: field,
            date: today,
            analysis: offer.labname,
            jobnumber: parameters.jobNumber,
            fieldmark: parameters.fieldMark,
            probes: parameters.probesCount
        };
        setLabData(data);
        setShowPDF(true);
    }



    function onSelectOfferChange(e) {
        console.log(e);
        setOffer(offers.filter(off => off.id == e)[0]);
        let selected = offers.filter(off => off.id == e)[0];
        if (selected) setOfferPrice(selected.price);
    }


    function onSelectProgressChange(e) {
        console.log('progress is changed');
        console.log(e);
        setProgress(e);
        let parray = PROGRESS.filter(p => p.id == e);
        if (parray.length == 1) {
            setStatus(parray[0].status);
        }
    }

    function onSelectTechChange(e) {
        console.log("Wybrany technik id " + e);
        console.log(typeof(e))
        setSelectedTech(e);
        var tech=techs.filter(t=>t.id==e)[0];
        setTechName(tech.firstname);
        console.log(tech.firstname);
    }

    function onSelectVehicleChange(e) {
        console.log("Wybrany pojazd esn " + e);
        console.log(typeof(e))
        setSelectedVehicle(e);
    }

    function onChangeFieldsSelected(selected)
    {
        setSelectedFields(selected);
    }



    function descriptionChange(e) {
        setDescription(e.target.value);
    }


    function handleDateChange(value) {
        console.log("final date :", value);
        setFinalDate(value);
    }

    function handleShowHistoryCard() {
        setShowHistoryCard(!showHistoryCard);
    }

    function handleShowSmsCard() {
        setShowSmsCard(!showSmsCard);
    }

    function handleShowEmailCard() {
        setShowEmailCard(!showEmailCard);
    }

    function handleNotChange(value) {

        if ((proposaldate.endDate == null) && (proposaldate.endDate == null)) { setProposalDate(value); console.log("changing proposal date : ", value); }
        else { console.log("not changing date : ", value); }
    }


    const FinalValueComponent = () => {
        const[value, setValue]= useState(parameters.finalValue);
        
        return( 
        <Input size="md" label="Cena końcowa" className="shadow-md text-center" type="text" value={value} name="finalValue" onChange={e =>setValue(e.target.value)} onBlur={handleParamChange}  />
        )
    }


    const LabFormComponent = () => {
        const[probes, _setProbes]= useState(parameters.probesCount);
        const[job, _setJob]= useState(parameters.jobNumber);
        const[fieldmark, _setFieldMark]= useState(parameters.fieldMark);

        return( 
                            <>
                                <div className='flex flex-row justify-between w-full gap-[1rem] max-w-[29rem]'>
                                    <Input size="md" label="Ilość pobranych próbek" className="w-[12rem] shadow-md text-center flex" name="probesCount" value={probes} onChange={e => _setProbes(e.target.value)} onBlur={handleParamChange}/>
                                    <Input size="md" label="Numer zlecenia" className="w-[12rem] shadow-md text-center flex" name="jobNumber" value={job} onChange={e => _setJob(e.target.value)} onBlur={handleParamChange}/>
                                </div>
                                <div className='flex flex-row justify-between w-full gap-[1rem] max-w-[29rem]'>
                                    <div className="flex w-[14rem]">
                                        <Input size="md" label="Oznaczenie pola" className="w-full shadow-md text-center flex" name="fieldMark" value={fieldmark} onChange={e => _setFieldMark(e.target.value)} onBlur={handleParamChange}/>
                                    </div>
                                    <div className="w-[14rem] flex items-center justify-center">
                                        <Tooltip content="Wygeneruj zlecenie dla Laboratorium">
                                            <IconButton variant='gradient' className='px-3' color="blue" data-refresh={false} onClick={generateLabForm} >
                                                <BeakerIcon className='w-6 h-6' />
                                            </IconButton>
                                        </Tooltip>
                                    </div>
                                </div>
                            </>
        )
    }




    return (
        
        <div className='absolute w-full h-full top-0 left-0 items-center shadow-md justify-cener flex overflow-y-auto overflow-x-none'>
            <Card color="white" className="w-[30rem] mx-auto px-0 my-auto py-4 shadow-xl shrink h-auto z-5 overflow-x-none" shadow={true}>

                <div className="flex flex-row justify-between gap-2 w-auto my-2 ml-6">
                    <Typography variant="h6" color="blue-gray" >
                        Karta zlecenia  #{orderId},  {((rank==5) && (client)) &&                       
                            client.name
                        }
                    </Typography>
                    <IconButton variant='text' className='top-[-1rem] right-2' color="blue-gray" data-refresh={false} onClick={cancelClose}>
                        <XMarkIcon className='w-6 h-6' />
                    </IconButton>
                </div>

                <form className="mt-2 mb-0 w-full items-center justify-center px-3 mx-0 " onSubmit={handleSubmit}>
                    <div className="mb-2 flex flex-col gap-3 w-full items-center justify-center ">

                        {rank==10 &&
                        <Select label="Klient" className="shadow-md" value={client ? client.id.toString() : ''} onChange={onSelectClientChange}>
                            {
                                clients.map((client) => (
                                    <Option key={client.id} value={client.id.toString()}>{client.name}</Option>
                                ))
                            }
                        </Select>
                        }
                        
                        {showFieldList && 
                        <div className='w-[26rem] h-[18rem]'>
                        <FieldsCheckList fields={clientFields} selected={selectedFields} completion={completionList} onChange={onChangeFieldsSelected} onChangeCompletion={onChangeCompletion}/>
                        </div>
                        }
                        {!showFieldList && 
                        <div className='w-[26rem] h-2'>
                        </div>
                        }
                        {showFieldList && 
                        <Tooltip content="Ukryj liste pól">
                        <IconButton variant="gradient" className='m-0 p-0 -top-6 left-0' size='sm' color="blue-gray" data-refresh={false} onClick={() => setShowFieldList(false)} >
                            <ChevronDoubleUpIcon className='w-4 h-4 stroke-[2px] color="blue-gray"' /> 
                        </IconButton>
                        </Tooltip>
                        }
                        {!showFieldList && 
                        <Tooltip content="Pokaż liste pól">
                        <IconButton variant="gradient" className='m-0 p-0 -top-6 left-0' size='sm' color="blue-gray" data-refresh={false} onClick={() => setShowFieldList(true)} >
                            <ChevronDoubleDownIcon className='w-4 h-4 stroke-[2px] color="blue-gray"' /> 
                        </IconButton>
                        </Tooltip>    
                        }
                        
                        {rank==10 && 
                        <div className='-mt-6 w-full'>
                        <Select label="Zakres badania " className="shadow-md" value={offer ? offer.id.toString() : ''} onChange={onSelectOfferChange}>
                            {
                                offers.map((value) => (
                                    <Option key={value.id} value={value.id.toString()}>{value.name + " (" + value.price + "zł / Ha)"}</Option>
                                ))
                            }
                        </Select>
                        </div>            
                        }    
                        {rank==10 &&        
                        <>
                        <Typography variant="small" color="blue-gray" className="relative mx-auto text-xs ml-0 mr-auto mb-0 top-1">
                            Sugerowany, przez klienta, zakres czasowy do wykonania zlecenia
                        </Typography>
                        <Datepicker i18n={"pl"} primaryColor="green" readOnly={true} value={proposaldate} onChange={handleNotChange} inputClassName="w-full border rounded-md shadow-md py-2 px-2 border-gray-400 text-gray-600 text-normal focus:border-blue-500 focus:outline-0 focus:ring-0" placeholder="Proponowana data realizacji" ></Datepicker>
                        </>  
                        }
                        <Typography variant="small" color="blue-gray" className="relative mx-auto text-xs ml-0 mr-auto mb-0 top-1">
                            Wybrana data wykonania zlecenia
                        </Typography>
                        <Datepicker i18n={"pl"} primaryColor="green" asSingle={false} value={finalDate} onChange={handleDateChange} inputClassName="w-full border rounded-md shadow-md py-2 px-2 border-gray-400 text-gray-600 text-normal focus:border-blue-500 focus:outline-0 focus:ring-0" placeholder="Proponowana data realizacji" ></Datepicker>
                        
                        

                        {rank==10 && 
                        <div className='flex max-w-[16rem] mt-2'>
                            <FinalValueComponent />
                        </div>
                        }    
                        <div className='flex w-full my-2'>
                            <Select label="Postęp realizacji zadania" className="shadow-md" value={order ? order.progress.toString() : ''} onChange={onSelectProgressChange}>
                                {
                                    PROGRESS.map((value) => {
                                        var disable=false;
                                        if ((rank==5) && ((value.id<25) || (value.id>40))) return(<></>); 
                                        return(<Option key={value.id} disabled={disable} value={value.id.toString()}>{value.status}</Option>)
                                    })
                                }
                            </Select>

                            <Tooltip content="Powiadom klienta SMS'em">
                                <IconButton variant='gradient' className='ml-4 px-3' color="blue" data-refresh={false} onClick={handleShowSmsCard} >
                                    <ChatBubbleLeftIcon className='w-6 h-6' />
                                </IconButton>
                            </Tooltip>
                            <Tooltip content="Powiadom klienta Email'em">
                                <IconButton variant='gradient' className='ml-3 px-3' color="blue" data-refresh={false} onClick={handleShowEmailCard} >
                                    <EnvelopeIcon className='w-6 h-6' />
                                </IconButton>
                            </Tooltip>

                        </div>

                        {progress >= 35 && <LabFormComponent />} 

                        {rank==10 && 
                        <div className='flex flex-row justify-between w-full gap-[1rem] max-w-[29rem]'>
                        <div className='flex w-[14rem] my-2 mx-auto'>
                            {techs.length>0 &&
                            <Select label="Przypisz technika" className="shadow-lg" value={selectedTech} onChange={onSelectTechChange}>
                                {
                                    techs.map((tech) => (
                                        <Option key={tech.id} value={tech.id.toString()}>{tech.firstname + " " + tech.lastname}</Option>
                                    ))
                                }
                            </Select>
                            }
                        </div>
                        <div className='flex w-[14rem] my-2 mx-auto'>
                            {vehicles.length>0 &&
                            <Select label="Przypisz pojazd" className="shadow-lg" value={selectedVehicle} onChange={onSelectVehicleChange}>
                                {
                                    vehicles.map((vehicle) => (
                                        <Option key={vehicle.esn} value={vehicle.esn.toString()}>{vehicle.name}</Option>
                                    ))
                                }
                            </Select>
                            }
                        </div>
                        </div>        

                        }

                        <Textarea  label="Uwagi" value={description} className="shadow-md mt-2 max-h-[6rem]" onChange={descriptionChange} />
                        

                        <div className='flex flex-row justify-between w-full mt-4 mb-0' >
                            {rank==10 && 
                            <IconButton variant='gradient' className='mr-4' color="red" data-refresh={false} onClick={() => setConfirm(true)} >
                                <TrashIcon className='w-6 h-6' />
                            </IconButton>
                            }
                            {rank==5 &&
                            <Tooltip content="Śledź zlecenie">
                            <IconButton variant='gradient' className='ml-0 mr-auto' color="deep-purple" data-refresh={false} onClick={() => startTrackingOrder()} >
                                <TruckIcon className='w-6 h-6' />
                            </IconButton>
                            </Tooltip>
                            }
                            {rank==10 && 
                            <Tooltip content="Zobacz historię zmian zlecenia" className="ml-4 mr-auto">
                            <IconButton variant='gradient' className='ml-4' color="blue" data-refresh={false} onClick={() => setShowHistoryCard(true)} >
                                <FingerPrintIcon className='w-6 h-6' />
                            </IconButton>
                            </Tooltip>
                            }
                            <Button className="items-center  mr-0 w-40 justify-center bg-gradient-to-br from-teal-500 to-cyan-500 " data-refresh={true} fullWidth type="submit">
                                Zapisz
                            </Button>
                        </div>
                    </div>

                </form>
            </Card>

            {showHistoryCard && <OrderHistoryList close={handleShowHistoryCard} properties={order.properties} />}            
            {showSmsCard && <SmsCard close={handleShowSmsCard} name={clientName} phone={phone} message={message} />}
            {showEmailCard && <EmailCard close={handleShowEmailCard} name={clientName} email={email} subject={subject} message={message} />}
            {showPDF && <PdfPreview close={() => setShowPDF(false)} props={labData} />}

            <Dialog open={confirm} size={"xs"} handler={setConfirm}>
                <DialogHeader>Jesteś pewien ?</DialogHeader>
                <DialogBody divider>
                    Czy na pewno chcesz usunąć to zlecenie
                </DialogBody>
                <DialogFooter>
                    <Button variant="text" color="red" onClick={() => setConfirm(false)} className="mr-8">
                        <span>Nie</span>
                    </Button>
                    <Button variant="gradient" color="green" onClick={() => deleteOrder()}>
                        <span>Tak</span>
                    </Button>
                </DialogFooter>
            </Dialog>


        </div>
    );


}

